import styled from 'styled-components';
import {
    colorBackground,
    colorText,
    headerHeight,
    mediaMd,
    mediaSm,
} from 'theme/theme-helper-selectors';
import {
    ButtonNavAction,
    NativeNavLink,
    RouterNavLink,
} from '../../header-link/styled';
import { DropdownContent } from '../../header-menu-dropdown/styled';

export const NavListItem = styled.li`
    display: flex;
    align-items: center;
    color: ${colorText};
    margin: 0 10px;

    @media (${mediaMd}) {
        margin: 0 6px;
    }

    @media (${mediaSm}) {
        &,
        ${DropdownContent} {
            margin: 0;
            width: 100%;
            border-bottom: 2px solid ${colorBackground};
            min-height: ${headerHeight};
            padding: 0 16px;
        }
    }

    ${NativeNavLink}, ${RouterNavLink}, ${ButtonNavAction} {
        padding: 12px 8px;
        font-size: 14px;
        font-weight: normal;
        transition: border 0.5s ease, color 0.5s ease;
        cursor: pointer;
        display: flex;
        align-items: center;
        white-space: nowrap;

        @media (${mediaMd}) {
            padding: 12px 6px;
            font-size: 14px;
        }

        @media (${mediaSm}) {
            border-width: 0;
            font-size: 18px;
            line-height: 24px;
            font-weight: 300;

            a {
                padding: 0;
            }
        }
    }

    ${NativeNavLink}, ${RouterNavLink} {
        height: 100%;

        @media (${mediaSm}) {
            width: 100%;
        }
    }
`;
